import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
// import store from '@/store'
import { getPowerSystemCookie } from './auth'

// create an axios instance
const service = axios.create({
  // baseURL: 'http://120.237.80.133:9095/api' // api 的 base_url
  baseURL: process.env.VUE_APP_BASE_API
  // baseURL: 'http://190.168.1.50:9095/api' // api 的 base_url
  // timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // const urlInfo = getPowerSystemCookie() ? JSON.parse(getPowerSystemCookie()) : {}
    // config.headers.Authorization = `Bearer ${urlInfo.token || ''}`
    const urlInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
    config.headers.Authorization = `Bearer ${urlInfo.token}`

    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 'success') {
      // if (res.message === 'token不可用') {
        // location.reload()
      // }
      // 401:token过期或者校验不通过; 403:token校验成功,但是无权限访问;
      if (res.code === 401 || res.code === 403 || res.code === '000005' || res.code === '000008') {
        // window.location.href = `${process.env.VUE_APP_POWER_SYSTEM_URL}?redirect=${window.location.href}`
      } else {
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(response.data)
    } else {
      // Message({
      //   message: res.message,
      //   type: 'success',
      //   duration: 5 * 1000
      // })

      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })

    return error
  }
)

export default service
